"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Devkit = function Devkit(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/products/devkit-devkit" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-devkit" + unique,
    xlinkHref: "#path-1-devkit" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-devkit" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5,7 L11.5,5.8662178 C11.7989007,5.69331309 12,5.37014118 12,5 C12,4.44771525 11.5522847,4 11,4 C10.4477153,4 10,4.44771525 10,5 C10,5.37014118 10.2010993,5.69331309 10.5,5.8662178 L10.5,7 L8,7 C7.44771525,7 7,7.44771525 7,8 L7,10.5 L5.8662178,10.5 C5.69331309,10.2010993 5.37014118,10 5,10 C4.44771525,10 4,10.4477153 4,11 C4,11.5522847 4.44771525,12 5,12 C5.37014118,12 5.69331309,11.7989007 5.8662178,11.5 L7,11.5 L7,14 L4,14 C3.44771525,14 3,13.5522847 3,13 L3,4 C3,3.44771525 3.44771525,3 4,3 L17,3 C17.5522847,3 18,3.44771525 18,4 L18,7 L17,7 L17,5 C17,4.72385763 16.7761424,4.5 16.5,4.5 L14.8662178,4.5 C14.6933131,4.20109931 14.3701412,4 14,4 C13.4477153,4 13,4.44771525 13,5 C13,5.55228475 13.4477153,6 14,6 C14.3701412,6 14.6933131,5.79890069 14.8662178,5.5 L16,5.5 L16,7 L11.5,7 Z M4.5,4 C4.22385763,4 4,4.22385763 4,4.5 L4,6.5 C4,6.77614237 4.22385763,7 4.5,7 L6.5,7 C6.77614237,7 7,6.77614237 7,6.5 L7,4.5 C7,4.22385763 6.77614237,4 6.5,4 L4.5,4 Z M10,9 L20,9 C20.5522847,9 21,9.44771525 21,10 L21,20 C21,20.5522847 20.5522847,21 20,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,10 C9,9.44771525 9.44771525,9 10,9 Z M13.9866275,16.9415479 L12.1926896,15.1162446 L13.9866275,13.2909413 C14.1644573,13.1100023 14.1644573,12.8166433 13.9866275,12.6357043 C13.8087977,12.4547652 13.5204796,12.4547652 13.3426498,12.6357043 L11.0673846,14.9507505 C11.0242396,14.9946382 11,15.0541698 11,15.1162446 C11,15.1783195 11.0242396,15.237851 11.0673846,15.2817388 L13.3426498,17.596785 C13.5204796,17.777724 13.8087977,17.777724 13.9866275,17.596785 C14.1644573,17.4158459 14.1644573,17.1224869 13.9866275,16.9415479 Z M17.9253529,15.1162446 L16.1332369,13.2909413 C15.9555877,13.1100023 15.9555877,12.8166433 16.1332369,12.6357043 C16.3108862,12.4547652 16.5989114,12.4547652 16.7765606,12.6357043 L19.049515,14.9507505 C19.0926162,14.9946382 19.1168311,15.0541698 19.1168311,15.1162446 C19.1168311,15.1783195 19.0926162,15.237851 19.049515,15.2817388 L16.7765606,17.596785 C16.5989114,17.777724 16.3108862,17.777724 16.1332369,17.596785 C15.9555877,17.4158459 15.9555877,17.1224869 16.1332369,16.9415479 L17.9253529,15.1162446 Z",
    fill: "inherit",
    id: "path-1-devkit" + unique
  }))));
};

Devkit.propTypes = propTypes;
var _default = Devkit;
exports["default"] = _default;